import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation AskAgent(
    $tenantId: ID!
    $zoneId: ID!
    $input: AgentChatMessageInput!
    $conversationContext: AgentChatMessageConversationContextInput!
    $knowledgeBaseRetrieval: AgentKnowledgeBaseRetrievalInput
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        askAgent(
          input: $input
          conversationContext: $conversationContext
          knowledgeBaseRetrieval: $knowledgeBaseRetrieval
        )
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.validate(
  graphql.transformers.OUT.select<
    graphql.schema.AskAgentMutation,
    undefined,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'askAgent',
        graphql.transformers.OUT.always(undefined),
      ),
    ),
  ),
  TypeAsserter.assertIsNotNullish,
  { warnOnly: true },
)

export const executor = graphql.createExecutor<
  graphql.schema.AskAgentMutation,
  undefined,
  graphql.schema.AskAgentMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
